import React from 'react';
import styled from 'styled-components';

import tree1 from '../../../../../../../assets/images/carbonOffset/tree-1.svg';
import tree2 from '../../../../../../../assets/images/carbonOffset/tree-2.svg';
import tree3 from '../../../../../../../assets/images/carbonOffset/tree-3.svg';
import tree4 from '../../../../../../../assets/images/carbonOffset/tree-4.svg';
import tree5 from '../../../../../../../assets/images/carbonOffset/tree-5.svg';

import { ImageList } from '../ImageList/index';

const Wrapper = styled.div`
  padding: 0 30px 0;
  display: flex;
  @media (max-width: 767px) {
    padding: 0 10px 0;
  }
`;

const Aligner = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
`;

const TreeWrapper = styled(Aligner)`
  @media (max-width: 767px) {
    display: none;
  }
`;

const TreeWrapperMobileOnly = styled(Aligner)`
  @media (min-width: 768px) {
    display: none;
  }
`;

const imagesTrees = [
  {
    image: tree1,
    maxWidth: 70,
    maxHeight: 130,
  },
  {
    image: tree2,
    maxWidth: 60,
    maxHeight: 110,
  },
  {
    image: tree3,
    maxWidth: 60,
    maxHeight: 54,
  },
  {
    image: tree4,
    maxWidth: 60,
    maxHeight: 115,
  },
  {
    image: tree5,
    maxWidth: 65,
    maxHeight: 130,
  },
];

const imagesTreesMobile = [
  {
    image: tree1,
    maxWidth: 40,
    maxHeight: 70,
  },
  {
    image: tree2,
    maxWidth: 20,
    maxHeight: 40,
  },
  {
    image: tree4,
    maxWidth: 40,
    maxHeight: 70,
  },
  {
    image: tree3,
    maxWidth: 30,
    maxHeight: 24,
  },
];

export const ModalFooter = () => {
  return (
    <Wrapper>
      <TreeWrapper>
        <ImageList list={imagesTrees} />
      </TreeWrapper>
      <TreeWrapperMobileOnly>
        <ImageList list={imagesTreesMobile} />
      </TreeWrapperMobileOnly>
    </Wrapper>
  );
};
